import { Box, Stack } from 'braid-design-system';
import { clsx } from 'clsx';

import * as styles from './index.css';

interface Props {
  lines?: number;
  first?: boolean;
  last?: boolean;
}

export const SearchResultPlaceholder = ({ lines = 5, first, last }: Props) => (
  <Box
    paddingX="gutter"
    className={clsx(styles.item, {
      [styles.firstItem]: first,
      [styles.lastItem]: last,
    })}
  >
    <Stack space="small">
      {[...Array(lines)].map((_l: undefined, i: number) => (
        <Box
          key={`placeholder-line-${i}`}
          background="neutralLight"
          className={styles.line}
        />
      ))}
    </Stack>
  </Box>
);
